<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>
<div class="mt-34 ml-24 mr-24">
  <ng-container *ngIf="!isLoading; else loader">
    <div class="top-panel p-24 mb-28 flex flex-row justify-start items-start" [ngClass]="{'disabled': showLoader}">
      <mat-icon svgIcon="arrow_back" class="cursor-pointer icon-lg" (click)="goToGroups()"></mat-icon>
      <div class="flex flex-col pl-24">
        <div class="mat-headline-5 fw-600 mb-14">
          {{ groupName | titlecase }}
        </div>
        <div class="mat-body fw-400 fs-14 description">
          {{ 'GROUPS.DESCRIPTION' | transloco }}:<span class="pl-4">{{group?.description ? group?.description : '-'}}</span>
        </div>
      </div>
    </div>
    <div class="tenant-roles mt-28" *ngIf="roleAssignments?.length > 0; else noDataFound" [ngClass]="{'disabled': showLoader}">
      <div class="header flex pl-30 pt-12 pb-12">
        <div class="tenant mat-subtitle-2 fw-700 fs-14">{{ 'GROUPS.TENANT' | transloco | uppercase }}</div>
        <div class="role mat-subtitle-2 fw-700 fs-14">{{ 'GROUPS.ROLE' | transloco | uppercase }}</div>
      </div>
      <ng-container *ngFor="let tenant of tenantRoles; let last = last">
        <div class="body flex pl-30 pt-12 pb-12" [ngClass]="{'body-element': !last}">
          <div class="tenant flex items-center">
            <div class="fw-500 ml-8">{{tenant?.tenant | titlecase}}</div>
          </div>
          <div class="role fw-500 flex flex-wrap gap-6">
            <ng-container *ngFor="let role of tenant?.roles">
              <div class="name pl-16 pr-10 pt-4 pb-4 flex items-center cursor-pointer" [ngClass]="{'pr-16': groupName === 'portal-management-user-admin'}" (click)="viewPermissions($event, tenant, role)">{{role | titlecase}}
                <mat-icon *ngIf="groupName !== 'portal-management-user-admin' && (permissionsMap[PermissionKeys.GROUP_UPDATE] || (permissionsMap[PermissionKeys.ROLE_ASSIGN_CREATE] && permissionsMap[PermissionKeys.ROLE_ASSIGN_UPDATE]))" svgIcon="close" class="ml-16 icon-sm close cursor-pointer" (click)="deleteRole($event, tenant, role)"></mat-icon>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
    <ng-template #noDataFound>
      <div class="mt-20 unauth-container flex items-center flex-col mb-20">
        <img class="image-style" src="/assets/images/no-roles.svg">
        <div class="fw-600 fs-24 mat-subtitle-2 mt-32"> {{ 'GROUPS.ROLE_NOT_ASSIGNED' | transloco }}</div>
        <button type="button" class="mt-22 flex justify-center items-center group-gradient mb-0 mat-subtitle-2 fs-16 fw-600" mat-button (click)="assignRole()">
          {{'GROUPS.ASSIGN_ROLE' | transloco }}
        </button>
      </div>
    </ng-template>
  </ng-container>
  <ng-template #loader>
    <div *ngIf="isLoading" class="flex spinner-container spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </div>
  </ng-template>
  <div *ngIf="showLoader">
    <mat-card class="flex spinner-container load-spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </mat-card>
  </div>
</div>
